import type { Column } from "@tanstack/react-table";

import { Icono } from "../Icono";

/**
 * Cabecera de columna: el título y, si la columna lo permite, el orden.
 *
 * El indicador de orden **siempre ocupa sitio**, también cuando la columna no
 * está ordenada: si apareciera al ordenar, la cabecera cambiaría de ancho y
 * toda la tabla daría un salto al hacer clic.
 */
export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
}: {
  column: Column<TData, TValue>;
  title: string;
}) {
  if (!column.getCanSort()) {
    return <span>{title}</span>;
  }

  const sorted = column.getIsSorted();
  const siguiente =
    sorted === false ? "ascendente" : sorted === "asc" ? "descendente" : "sin ordenar";

  return (
    <button
      type="button"
      onClick={() => column.toggleSorting(sorted === "asc")}
      // El estado va en aria-sort, en el `th`, no aquí: un lector de pantalla
      // anuncia el orden al entrar en la columna, no al enfocar el botón.
      aria-label={`${title}: ordenar ${siguiente}`}
      className="group inline-flex items-center gap-1 rounded transition hover:text-slate-200 focus:outline-none focus-visible:ring-1 focus-visible:ring-sky-400/60"
    >
      {title}
      <span
        aria-hidden
        className={`transition ${sorted === false ? "opacity-0 group-hover:opacity-60" : "opacity-100"}`}
      >
        <Icono
          nombre={sorted === "asc" ? "orden-asc" : sorted === "desc" ? "orden-desc" : "orden"}
          className="h-3 w-3"
        />
      </span>
    </button>
  );
}
